window.chris = window.chris || {};
window.theme = window.theme || {};

/*================ Chris ================*/

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

chris.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

chris.utils = {
  /**
   * Check if mobile device
   *
   */
  isMobileDevice: function () {
    return (
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    );
  },

  /**
   * Convert rem to pixels

   * @param {string} rem - rem value
   */
  convertRemToPixels: function (rem) {
    return (
      rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    );
  },

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

chris.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = chris.utils.defaultTo(precision, 2);
      thousands = chris.utils.defaultTo(thousands, ",");
      decimal = chris.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

chris.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

chris.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.prop("nodeName");
          var currentOption = {};

          // console.log(type);

          // changed some stuff here

          if (type === "SELECT") {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            console.log(currentOption);

            return currentOption;
          } else {
            currentOption.value = $element.find("input:checked").val();
            currentOption.index = $element.data("index");

            console.log(currentOption);

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = chris.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      //console.log(variant);

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Sections ================*/

chris.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

chris.Sections.prototype = $.extend({}, chris.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = chris.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = chris.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = chris.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = chris.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = chris.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = chris.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = chris.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new chris.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = chris.Image.imageSize(
        this.$featuredImage.attr("src")
      );
      chris.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        return;
      }

      if (
        variant.available &&
        $(selectors.addToCart, this.$container).data("preOrder")
      ) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.preOrder
        );
      } else if (
        variant.available &&
        !$(selectors.addToCart, this.$container).data("preOrder")
      ) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        chris.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          chris.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = chris.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr("src", sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

$(document).ready(function () {
  doHeader();

  var sections = new chris.Sections();
  sections.register("product", theme.Product);

  // Apply a specific class to the html element for browser support of cookies.
  if (chris.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }

  // product add

  $('form[action="/cart/add"]').submit(function (event) {
    event.preventDefault();
    var addToCartForm = $(this);

    // Disable add to cart button.
    addToCartBtn = addToCartForm.find('button[type="submit"]');

    // Add to cart.
    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      type: "post",
      data: addToCartForm.serialize(),
      beforeSend: function () {
        addToCartBtn.find("[data-add-to-cart-text]").html("Adding to Cart...");
      },
      success: function (product, cart) {
        $.getJSON("/cart.js", function (cart) {
          $("#cartCount").html(cart.item_count);
        });

        addToCartBtn.find("[data-add-to-cart-text]").html("Add More");

        //$('#product-buttons').hide();
        $("#cart-link").show();
      },
      error: function () {
        alert("Item was not added to cart!");
      },
    });
  });

  // cart
  // $('.qty button').on('click', function() {

  //   var $button = $(this);
  //   var oldValue = $button.parent().find('input').val();

  //   if ($button.text() == '+') {
  //     var newVal = parseFloat(oldValue) + 1;
  //   } else {
  //     // Don't allow decrementing below zero
  //     if (oldValue > 0) {
  //       var newVal = parseFloat(oldValue) - 1;
  //     } else {
  //       newVal = 0;
  //     }
  //   }

  //   $button.parent().find('input').val(newVal);

  //   //if in cart
  //   if ($('body').hasClass('template-cart')) {

  //       var item = $button.closest('.item'),

  //       variant_id = item.attr('id'),

  //       item_total = item.find('.line-item-total'),

  //       subtotal =  $('.cart-total-price');

  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/change.js',
  //         dataType: 'json',
  //         data: {
  //           quantity: newVal,
  //           id: variant_id
  //         },
  //         success: function(cart) {

  //           if ( newVal == 0 ) {

  //             item.remove();
  //           } else {

  //             $.each(cart.items,function(index,row) {
  //               if ( variant_id == row.variant_id ) item_total.html( '$' + parseFloat(row.line_price / 100).toFixed(2) );
  //             });

  //             $('#cartCount').html(cart.item_count);

  //           }
  //         subtotal.html( '$' + parseFloat(cart.total_price / 100).toFixed(2) );

  //       },
  //       error: function(response) {
  //         alert(response);
  //       }
  //       });

  //   }

  // });

  //currency selection

  $(".shopify-currency-form select").on("change", function () {
    $(this).parents("form").submit();
  });

  var parameters = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    spaceBetween: chris.utils.convertRemToPixels(2),
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: false,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    init: false,
  };

  // console.log(chris.utils.convertRemToPixels(2));

  $(".gallery").each(function () {
    parameters.navigation = {
      nextEl: $(this).parent().find(".btn-next")[0],
      prevEl: $(this).parent().find(".btn-prev")[0],
    };

    if ($(this).hasClass("fade")) {
      parameters.autoplay = false;
      parameters.allowTouchMove = false;
      parameters.simulateTouch = false;
      parameters.effect = "fade";
      parameters.loop = true;
      parameters.speed = 150;
    }

    newSwiper = new Swiper(this, parameters);

    newSwiper.on("init", function () {});

    newSwiper.init();

    if ($(this).hasClass("hero-slider")) {
      // gsap.set(this, {
      //   overflow: 'hidden',
      // });

      // gsap.to(this, {
      //   scrollTrigger: {
      //     trigger: false,
      //     pin: false,
      //     start: 0,
      //     end: window.innerHeight,
      //     scrub: true,
      //   },
      //   y: -window.innerHeight /2,
      //   ease: 'none',
      // });

      let checkIfReverse = () => {
        if ($(".hero-slider .swiper-slide-active").hasClass("light")) {
          $("body").addClass("reverse");
        } else {
          $("body").removeClass("reverse");
        }
      };
      newSwiper.on("slideChangeTransitionStart", () => {
        checkIfReverse();
      });
    }
  });

  productImages();

  doHeader();

  if ($(".zoom").length) {
    doZooms();
  }

  doStuff();

  modals();

  hackMenu();

  $(".afterpay-logo").wrap('<div class="afterpay-logo-wrapper"></div>');

  $(".afterpay-logo-wrapper").html("Afterpay");

  $(".bodyMenu").on("click mouseenter", (event) => {
    // console.log(event);

    if (event.type == "mouseenter" && !$("body").hasClass("menu")) {
      $("body").addClass("menu");
    }

    if (event.type == "click") {
      $("body").toggleClass("menu");
    }
  });

  // do dropdown
  // $('.nav-item-has-children > a').on('click', function(event) {

  //   $this = $(this);
  //   if ($('.header').hasClass('headroom--not-top') ) {
  //     event.preventDefault();
  //     if($this.parent().hasClass('open')) {
  //       $this.parent().removeClass('open');
  //     } else {
  //       $this.parent().addClass('open');
  //     }
  //   }
  // });
});

$(window).on("resize", () => {
  // hackMenu();
  // $('body').removeClass('menu');
  // doSomeThing();
});

const doSomeThing = () => {
  $("main").css({ marginTop: $(".header").outerHeight() });
};
// const openMenu = () => {
//   gsap.to('header .menu-main-container', {
//     height: 'auto',
//     duration: 0.3,
//     ease: 'power3.inOut',
//   });
// }

// const closeMenu = () => {
//   gsap.to('header .nav-container', {
//     height: 0,
//     duration: 0.3,
//     ease: 'power3.inOut',
//   });
// }

const hackMenu = () => {
  $(".bodyMenu .icon").css({
    width: $(".logo img").outerHeight(),
    height: $(".logo img").outerHeight(),
    opacity: 1,
  });
};

const doZooms = () => {
  $(".zoom").each(function () {
    $(this).on("click", function () {
      $(".zoom-container img").attr("src", $(this).attr("src"));
      $("body").addClass("zoomed");
    });
  });

  $(".zoom-container").on("click", () => {
    $("body").removeClass("zoomed");
  });
};

const doHeader = () => {
  var options = {
    // offset : 0,
    offset: {
      up: 0,
      down: $(".header").outerHeight() / 2,
    },
    tolerance: 0,
    // tolerance : {
    //   up : 5,
    //   down : 0,
    // },
    classes: {
      initial: "headroom",
      pinned: "headroom--pinned",
      unpinned: "headroom--unpinned",
      top: "headroom--top",
      notTop: "headroom--not-top",
      bottom: "headroom--bottom",
      notBottom: "headroom--not-bottom",
      frozen: "headroom--frozen",
      pinned: "headroom--pinned foo bar",
    },
    scroller: window,
    // onPin : function() {},
    onUnpin: function () {
      $("body").removeClass("menu");
    },
    // onTop : function() {},
    // onNotTop : function() {},
    // onBottom : function() {},
    // onNotBottom : function() {},
  };

  var header = document.querySelector(".header");
  var headroom = new Headroom(header, options);

  headroom.init();
};

var doStuff = () => {
  let posts = document.querySelectorAll(".posts .post");
  for (let i = 0; i < posts.length; i++) {
    let post = posts[i];

    let postInner = post.querySelector(".product-inner");

    postInner.addEventListener("mouseenter", (event) => {
      var info = postInner.querySelector(".info").innerHTML;
      document.querySelector(".info-container").innerHTML = info;

      gsap.set(".info-container", {
        autoAlpha: 1,
      });
    });

    postInner.addEventListener("mouseleave", (event) => {
      gsap.set(".info-container", {
        autoAlpha: 0,
      });
      // if (window.innerWidth < chris.utils.convertRemToPixels(64)){

      // }
    });

    // var tl = gsap.timeline({
    //   scrollTrigger: {
    //     scroller: window,
    //     trigger: post,
    //     start: 'top bottom',
    //     end : 'bottom top',
    //     scrub: true,
    //     // toggleActions: 'play none none reset',
    //     // markers: true,
    //     // onRefresh: () => {
    //     //   console.log('refreshed');
    //     // },
    //   },
    // });

    // tl.to(img, {
    //   scale: 1.2,
    //   ease: 'easeOut',
    // });

    // tl.to(img, {
    //   scale: 1,
    //   ease: 'easeOut',
    // });
  }

  // if(!chris.utils.isMobileDevice() ) {

  //   let mouseX = () => {

  //     let mouse = { x: 0, y: 0, moved: false };

  //     window.addEventListener('mousemove', (event) => {
  //       mouse.moved = true;
  //       mouse.x = event.clientX;
  //       mouse.y = event.clientY;
  //     });

  //     let mouseMoved = () => {

  //       if (mouse.moved){

  //         gsap.to('.index .posts .post .inner', {
  //           x: (mouse.x - window.innerWidth / 2) / window.innerWidth * -30,
  //           ease: Sine.easeOut,
  //         });
  //       }

  //       mouse.moved = false;
  //     }

  //     gsap.ticker.add(mouseMoved);

  //   }

  //   mouseX();
  // }
};

function productImages() {
  if (
    $("body").hasClass("product") ||
    $("body").hasClass("product-pre-order")
  ) {
    var mobileSwiper = "";

    var breakpoint = window.matchMedia("(min-width:768px)");

    var toggleSlider = () => {
      if (breakpoint.matches === true) {
        console.log("does");

        //disable mobile swiper
        if (mobileSwiper != "") {
          mobileSwiper.destroy(true, true);
          mobileSwiper = "";
          removeClasses();
        }
      } else if (breakpoint.matches === false) {
        console.log("does not");

        //enable
        enableMobile();
      }
    };

    var addClasses = () => {
      $(".product-images").addClass("swiper-container");
      $(".product-images > div ").addClass("swiper-wrapper");
      $(".product-images > div > div ").addClass("swiper-slide");
    };

    var removeClasses = () => {
      $(".product-images").removeClass("swiper-container");
      $(".product-images > div ").removeClass("swiper-wrapper");
      $(".product-images > div > div ").removeClass("swiper-slide");
    };

    var enableMobile = () => {
      addClasses();

      mobileSwiper = new Swiper(".product-images", {
        autoHeight: true,
        spaceBetween: chris.utils.convertRemToPixels(2),
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
      });

      mobileSwiper.on("slideChangeTransitionEnd", function () {
        $(".btn-prev, .btn-next").css({
          display: "none",
        });
      });
    };

    removeClasses();

    breakpoint.addListener(toggleSlider);

    toggleSlider();
  }
}

// modals

const modals = () => {
  if ($(".blocker").length) {
    function openModal(modal) {
      $("body, .blocker").addClass("modalActive");
      modal.addClass("modalActive");
    }

    function closeModal(modal) {
      modal.removeClass("modalActive");
      $("body, .blocker").removeClass("modalActive");
    }

    $(".modal").each(function (index, element) {
      var $this = $(this);

      $('[data-open-modal="' + $this.attr("id") + '"]').on(
        "click",
        function (event) {
          event.preventDefault();
          openModal($this);
        }
      );

      $(".blocker").on("click", function (event) {
        if (event.target.className == "blocker modalActive") {
          closeModal($(".modal.modalActive"));
        }
      });

      $(".close").on("click", function (event) {
        closeModal($(".modal.modalActive"));
      });
    });

    $(document).on("keydown", function (event) {
      if (event.key == "Escape") {
        if ($(".modal.modalActive").length) {
          closeModal($(".modal.modalActive"));
        }
      }
    });
  }
};

const removeThis = (elem) => {
  // elem.remove();
  elem.style.display = "none";
};

const dointro = () => {
  let intro = document.querySelector(".intro");

  intro.style.display = "flex";

  $(intro).on("click touchmove", function () {
    gsap.to(intro, {
      opacity: 0,
      duration: 1,
      delay: 0,
      onComplete: removeThis,
      onCompleteParams: [intro],
    });
    sessionStorage.setItem("intro", 1);
  });
};

const doAnimation = () => {
  var time = 12;

  var posts = document.querySelectorAll(".post");

  var number;

  gsap.defaults({
    delay: 0,
    ease: "none",
  });

  const master = gsap.timeline({
    // paused: true,
    repeat: -1,
  });

  const main = gsap.timeline({
    paused: true,
  });

  const isMobileDevice = () => {
    return (
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    );
  };

  const convertRemToPixels = (rem) => {
    return (
      rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    );
  };

  var counttx = 0,
    countup = true;
  var reset1 = (elem, i) => {
    if (countup) {
      ++counttx;
      if (counttx >= 2) countup = false;
    } else {
      --counttx;
      if (counttx <= 0) countup = true;
    }

    //console.log(counttx);
    if (counttx === 0) {
      number = gsap.utils.random(
        -window.innerWidth * 0.25,
        window.innerWidth * 0.25,
        5
      );
    } else if (counttx === 1) {
      number = gsap.utils.random(
        window.innerWidth * 0.25,
        window.innerWidth * 0.5,
        5
      );
    } else if (counttx === 2) {
      number = gsap.utils.random(
        window.innerWidth * 0.5,
        window.innerWidth * 0.75,
        5
      );
    }

    gsap.set(elem, {
      x: number,
    });

    if (i == posts.length - 1) {
      gsap.set(posts[0], {
        x: number,
      });
    }
  };

  const initTimeline = () => {
    for (let i = 0; i < posts.length; i++) {
      let post = posts[i];

      reset1(post);

      gsap.set(post, {
        opacity: 1,
      });

      let tl = gsap.timeline();

      tl.fromTo(
        post,
        {
          y: window.innerHeight,
        },
        {
          y: -post.offsetHeight,
          duration: time,
          onStart: reset1,
          onStartParams: [post, i],
        }
      );

      main.add(tl, ">-" + (time * 0.33).toFixed(1));

      post.addEventListener("mouseenter", (event) => {
        master.timeScale(0.25);

        // info = post.querySelector('.info').innerHTML;
        // console.log(info );
        // document.querySelector('.info-container').innerHTML = info;

        // gsap.set('.info-container', {
        //   autoAlpha: 1,
        // });
      });

      post.addEventListener("mouseleave", (event) => {
        master.timeScale(1);
        // gsap.set('.info-container', {
        //   autoAlpha: 0,
        // });
      });
    }

    if (!isMobileDevice()) {
      // if(!chris.utils.isMobileDevice() ) {

      document.body.addEventListener("wheel", (event) => {
        var progress = master.progress();

        progress += event.deltaY / 10000;

        if (progress > 0) {
          master.progress(progress);
        }
      });

      // let mouseX = () => {

      //   let mouse = { x: 0, y: 0, moved: false };

      //   window.addEventListener('mousemove', (event) => {
      //     mouse.moved = true;
      //     mouse.x = event.clientX;
      //     mouse.y = event.clientY;
      //   });

      //   let mouseMoved = () => {

      //     if (mouse.moved){

      //       gsap.to('.post img', {
      //         x: (mouse.x - window.innerWidth / 2) / window.innerWidth * -30,
      //         ease: Sine.easeOut,
      //       });
      //     }

      //     mouse.moved = false;
      //   }

      //   gsap.ticker.add(mouseMoved);

      // }

      // mouseX();
    } else {
      // document.body.addEventListener('touchmove', (event) => {
      //   console.log(addTouchOffsets(event).offsetY / 1e14);
      //   var progress = main.progress();
      //   progress += addTouchOffsets(event).offsetY / 1e14;
      //   if(progress > 0){
      //     main.progress(progress).play();
      //   }
      // });
    }

    var b = time * 0.5;
    var u = time * 0.3333333333333333;
    var t = time * 0.6666666666666666;
    var s = posts.length - 1;
    var x = s * t;
    // console.log(b+x);

    master.add(main.tweenFromTo(b, b + x));
  };

  initTimeline();

  $(window).on("resize", function () {
    location.reload();
  });

  // GSDevTools.create({
  //   animation: master
  // });
};

// auto scroll horizontal
// const autoScrollHorizontal = () => {

//   gsap.registerPlugin(ScrollToPlugin);

//   var rate = 50;

//   var main = document.querySelector('main');

//   var postContainer = main.querySelector('.horizontal-post-container');

//   console.log(postContainer);

//   var distance = postContainer.offsetWidth - window.innerWidth;

//   var time = distance/rate;

//   var timeline = gsap.timeline({
//     repeat: -1,
//     yoyo: true,
//   });

//   timeline.to(main, {
//     duration: time,
//     scrollTo: distance,
//     ease: 'sine.inOut',
//   });
// }

$(window).on("load", function () {
  if ($(".doAnimation").length) {
    doAnimation();
  }

  // if ($('#test-page').length) {
  //   autoScrollHorizontal();
  // }
});
